import { useTheme } from "@material-ui/core";
import React from "react";
import RangeField from "./RangeField";
import UserField from "./UserField";

const TitleField = ({
	source,
	record,
	basePath,
	sortable,
	isAdmin,
	...props
}) => {
	const theme = useTheme();
	return (
		<React.Fragment>
			<RangeField
				{...props}
				source="range"
				record={record}
				variant="subtitle1"
				style={{ fontWeight: "bold", display: "inline" }}
			/>
			{isAdmin && (
				<UserField
					{...props}
					variant="caption"
					source="user.name"
					style={{ marginLeft: theme.spacing(1), display: "inline" }}
					record={record}
				/>
			)}
		</React.Fragment>
	);
};
export default TitleField;
